// Wrapper que selecciona la pantalla de reservas adecuada según el rol del usuario.

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { ReservasAlumno } from '@/pages/ReservasAlumno';
import { ReservasProfesor } from '@/pages/ReservasProfesor';

export function Reservas() {
  const { state } = useAuth();
  if (state.status !== 'authenticated') return null;
  const roles = state.user.roles;
  if (roles.includes('admin')) {
    return <Navigate to="/admin/usuarios" replace />;
  }
  if (roles.includes('teacher')) {
    return <ReservasProfesor />;
  }
  return <ReservasAlumno />;
}
